import { useParams, useSearchParams } from "react-router";

import { getPermissions } from "entities/permissions";
import { Layout } from "pages/ui/page";
import { useConnectedAccountsQuery } from "shared/api/use-connected-accounts-query";

import { AppleConnect } from "./apple-connect";
import { GoogleConnect } from "./google-connect";

export const Connect = () => {
  const { type } = useParams<{ type: "google" | "apple" }>();

  const [searchParams] = useSearchParams();
  // The OAuth return deep link cannot carry `@`/`.` through the Telegram
  // start param, hence the substitution encoding.
  const safeEmail = searchParams.get("email");
  const email = safeEmail?.replace("000at000", "@").replace("000dot000", ".");

  const query = useConnectedAccountsQuery(
    { name: email ?? "", type: "google" },
    { enabled: Boolean(email) }
  );

  const account = query.data?.connected_accounts[0];

  return (
    <Layout back={!email} isLoading={Boolean(email && query.isPending)}>
      {type === "google" && (!email || query.isSuccess) && (
        <GoogleConnect
          initialInstructions={account?.instructions}
          initialPermissions={
            account ? getPermissions(account.scopes, "google") : undefined
          }
          initialScopes={account?.scopes}
          email={email}
        />
      )}
      {type === "apple" && <AppleConnect />}
    </Layout>
  );
};
